// UPDATED: All amounts are now in USD
export const PLANS = [
  { 
    id: 1, 
    name: "Basic Staking", 
    roi: "2x", 
    duration: "60 months", 
    frequency: "End Only", 
    min: 100, // $100 USD
    max: 20000, // $20,000 USD
    description: "Double your investment after 5 years",
    roiPercentage: 200,
    requiresReferrals: false,
    referralCommission: 6,
    capitalWithdrawAllowed: false
  },
  { 
    id: 2, 
    name: "Regular Monthly", 
    roi: "2.5%", 
    duration: "60 months", 
    frequency: "Monthly", 
    min: 500, // $500 USD
    max: 20000, // $20,000 USD
    description: "Monthly returns for 5 years",
    roiPercentage: 250,
    requiresReferrals: true,
    referralCommission: 6,
    capitalWithdrawAllowed: true
  },
  { 
    id: 3, 
    name: "Regular Monthly", 
    roi: "3%", 
    duration: "36 months", 
    frequency: "Monthly", 
    min: 500, // $500 USD
    max: 20000, // $20,000 USD
    description: "Higher monthly returns for 3 years",
    roiPercentage: 300,
    requiresReferrals: true,
    referralCommission: 6,
    capitalWithdrawAllowed: true
  },
  { 
    id: 4, 
    name: "Super Daily", 
    roi: "0.19%", 
    duration: "1825 days", 
    frequency: "Daily", 
    min: 500, // $500 USD
    max: 20000, // $20,000 USD
    description: "Daily returns for 5 years",
    roiPercentage: 19,
    requiresReferrals: true,
    referralCommission: 6,
    capitalWithdrawAllowed: false
  },
  { 
    id: 5, 
    name: "Prime Yearly", 
    roi: "3.5%", 
    duration: "36 months", 
    frequency: "Yearly", 
    min: 500, // $500 USD
    max: 20000, // $20,000 USD
    description: "Yearly withdrawal for 3 years",
    roiPercentage: 350,
    requiresReferrals: true,
    referralCommission: 6,
    capitalWithdrawAllowed: true
  },
  { 
    id: 6, 
    name: "Prime End", 
    roi: "4%", 
    duration: "36 months", 
    frequency: "End Only", 
    min: 500, // $500 USD
    max: 20000, // $20,000 USD
    description: "Total payout after 3 years",
    roiPercentage: 400,
    requiresReferrals: false,
    referralCommission: 6,
    capitalWithdrawAllowed: true
  },
  { 
    id: 7, 
    name: "Best Value", 
    roi: "5%", 
    duration: "60 months", 
    frequency: "End Only", 
    min: 500, // $500 USD
    max: 20000, // $20,000 USD
    description: "Highest returns after 5 years",
    roiPercentage: 500,
    requiresReferrals: false,
    referralCommission: 6,
    capitalWithdrawAllowed: true
  },
  { 
    id: 8, 
    name: "Prime Super Daily", 
    roi: "0.19%", 
    duration: "1825 days", 
    frequency: "End Only", 
    min: 500, // $500 USD
    max: 20000, // $20,000 USD
    description: "Accumulated daily returns paid at end",
    roiPercentage: 19,
    requiresReferrals: false,
    referralCommission: 6,
    capitalWithdrawAllowed: true
  },
  { 
    id: 9, 
    name: "Prime Basic", 
    roi: "0.072%", 
    duration: "1825 days", 
    frequency: "End Only", 
    min: 100, // $100 USD
    max: 25000, // $25,000 USD
    description: "Conservative long-term growth",
    roiPercentage: 7,
    requiresReferrals: false,
    referralCommission: 0,
    capitalWithdrawAllowed: false
  },
  {
    id: 10,
    name: "Prime Basic Super",
    roi: "0.072%",
    duration: "1825 days",
    frequency: "Daily",
    min: 100, // $100 USD
    max: 25000, // $25,000 USD
    description: "Conservative daily returns",
    roiPercentage: 7,
    requiresReferrals: false,
    referralCommission: 0,
    capitalWithdrawAllowed: false
  },
  // ---- ADDITIONAL PLANS (11-14) ----
  {
    id: 11,
    name: "Basic Bounty",
    roi: "Referral Only",
    duration: "—",
    frequency: "End Only",
    min: 25, // $25 USD
    max: 300, // $300 USD
    description: "No staking rewards. Earn 6% direct referral + 20-level commissions + RIA.",
    roiPercentage: 0,
    requiresReferrals: false,
    referralCommission: 6,
    capitalWithdrawAllowed: false,
    referralOnly: true
  },
  {
    id: 12,
    name: "Super Basic 1",
    roi: "Referral Only",
    duration: "—",
    frequency: "End Only",
    min: 50, // $50 USD
    max: 300, // $300 USD
    description: "No staking rewards. Earn 25% direct referral + levels + RIA.",
    roiPercentage: 0,
    requiresReferrals: false,
    referralCommission: 25,
    capitalWithdrawAllowed: false,
    referralOnly: true
  },
  {
    id: 13,
    name: "Super Basic 2",
    roi: "Referral Only",
    duration: "—",
    frequency: "End Only",
    min: 50, // $50 USD
    max: 5000, // $5,000 USD
    description: "No staking rewards. Earn 50% direct referral + levels + RIA.",
    roiPercentage: 0,
    requiresReferrals: false,
    referralCommission: 50,
    capitalWithdrawAllowed: false,
    referralOnly: true
  },
  {
    id: 14,
    name: "Prime Basic 0",
    roi: "1.66%",
    duration: "60 months",
    frequency: "Monthly",
    min: 50, // $50 USD
    max: 250000, // $250,000 USD
    description: "1.66% monthly for 60 months (no capital return). 6% referral + levels + RIA.",
    roiPercentage: 166,
    requiresReferrals: false,
    referralCommission: 6,
    capitalWithdrawAllowed: false
  }
];

// UPDATED: Achievement levels with proper USD values
// Thresholds match the contract's getAchievementLevel (team volume in USD + rank/direct requirements)
export const ACHIEVEMENT_LEVELS = {
  0: { name: "UNRANKED", color: "#94a3b8", requirement: "No achievements yet", icon: "🔰", teamVolume: 0, directRefs: 0 },
  1: { name: "Cluster", color: "#8B4513", requirement: "3+ direct referrals & $3K+ team volume", icon: "🌟", teamVolume: 3000, directRefs: 3 },
  2: { name: "Bronze", color: "#CD7F32", requirement: "3 Cluster & $9K+ team volume", icon: "🥉", teamVolume: 9000, directRefs: 0 },
  3: { name: "Silver", color: "#C0C0C0", requirement: "3 Bronze & $27K+ team volume", icon: "🥈", teamVolume: 27000, directRefs: 0 },
  4: { name: "Gold", color: "#FFD700", requirement: "3 Silver & $81K+ team volume", icon: "🥇", teamVolume: 81000, directRefs: 0 },
  5: { name: "Platinum", color: "#E5E4E2", requirement: "3 Gold & $243K+ team volume", icon: "💎", teamVolume: 243000, directRefs: 0 },
  6: { name: "Diamond", color: "#B9F2FF", requirement: "3 Platinum & $729K+ team volume", icon: "💍", teamVolume: 729000, directRefs: 0 },
  7: { name: "Double Diamond", color: "#4169E1", requirement: "2 Diamond & $1.458M+ team volume", icon: "💎💎", teamVolume: 1458000, directRefs: 0 },
  8: { name: "Triple Diamond", color: "#9400D3", requirement: "3 Diamond & $2.187M+ team volume", icon: "💎💎💎", teamVolume: 2187000, directRefs: 0 },
  9: { name: "Crown", color: "#FF6347", requirement: "3 Triple Diamond & $6.561M+ team volume", icon: "👑", teamVolume: 6561000, directRefs: 0 }
};

export const ACTIVITY_TYPES = {
  1: { name: "Staking", icon: "💰", color: "#4ecdc4" },
  2: { name: "Rewards Withdrawal", icon: "📈", color: "#51cf66" },
  3: { name: "Referral Reward", icon: "👥", color: "#ff6b6b" },
  4: { name: "Level Reward", icon: "🏆", color: "#ffd43b" },
  5: { name: "Capital Withdrawal", icon: "💵", color: "#fa5252" },
  6: { name: "RIA Retopup", icon: "🔁", color: "#a855f7" } // NEW: Recurring Income Activation retopup
};

export const WITHDRAWAL_FREQUENCIES = {
  0: "Daily",
  1: "Monthly", 
  2: "Yearly",
  3: "End Only"
};

// Level Commission Structure from Contract
export const LEVEL_COMMISSIONS = {
  1: 0,    // Direct referral (already paid separately as 6%)
  2: 100,  // 1%
  3: 300,  // 3%
  4: 400,  // 4%
  5: 600,  // 6%
  6: 100,  // 1%
  7: 75,   // 0.75%
  8: 75,   // 0.75%
  9: 75,   // 0.75%
  10: 75,  // 0.75%
  11: 50,  // 0.5%
  12: 50,  // 0.5%
  13: 50,  // 0.5%
  14: 50,  // 0.5%
  15: 50,  // 0.5%
  16: 12,  // 0.125%
  17: 12,  // 0.125%
  18: 12,  // 0.125%
  19: 12,  // 0.125%
  20: 12   // 0.125%
};

// Helper function to get commission percentage display
export const getLevelCommissionDisplay = (level) => {
  const commission = LEVEL_COMMISSIONS[level];
  if (commission === 0) return "6% (Direct)";
  if (commission >= 100) return `${commission / 100}%`;
  return `${commission / 100}%`;
};

export const DEFAULT_SETTINGS = {
  REFRESH_INTERVAL: 30000, // 30 seconds
  MAX_DECIMAL_PLACES: 6,
  MIN_STAKE_AMOUNT: 25, // $25 USD (Plan 11 Basic Bounty)
  MAX_STAKE_AMOUNT: 250000, // $250,000 USD (Plan 14 Prime Basic 0)
  TRANSACTION_TIMEOUT: 60000, // 1 minute
  DEFAULT_TOKEN_PRICE: 2.0 // $2 per token - will be fetched from contract
};

export const NETWORK_PARAMS = {
  opBNB: {
    chainId: '0xCC',
    name: 'opBNB Mainnet',
    symbol: 'BNB',
    decimals: 18,
    explorerUrl: 'https://opbnbscan.com',
    rpcUrl: 'https://opbnb-mainnet-rpc.bnbchain.org'
  },
  opBNBTestnet: {
    chainId: '0x15EB',
    name: 'opBNB Testnet', 
    symbol: 'tBNB',
    decimals: 18,
    explorerUrl: 'https://testnet.opbnbscan.com',
    rpcUrl: 'https://opbnb-testnet-rpc.bnbchain.org'
  }
};

export const ERROR_MESSAGES = {
  WALLET_NOT_CONNECTED: 'Please connect your wallet first',
  INSUFFICIENT_BALANCE: 'Insufficient token balance',
  INSUFFICIENT_TOKEN_BALANCE: 'Insufficient token balance for this USD amount',
  INVALID_AMOUNT: 'Please enter a valid amount',
  INVALID_USD_AMOUNT: 'Please enter a valid USD amount',
  AMOUNT_TOO_LOW: 'Amount is below minimum required',
  AMOUNT_TOO_HIGH: 'Amount exceeds maximum allowed',
  NETWORK_ERROR: 'Network error. Please check your connection',
  TRANSACTION_FAILED: 'Transaction failed. Please try again',
  USER_REJECTED: 'Transaction rejected by user',
  ADMIN_ONLY: 'This function is only available for admin users',
  PLAN_NOT_FOUND: 'Plan not found',
  INVESTMENT_NOT_FOUND: 'Investment not found',
  ALREADY_REGISTERED: 'User already registered',
  CONTRACT_CALL_FAILED: 'Contract call failed. Please try again',
  INSUFFICIENT_REFERRALS: 'Referral requirement not met for this plan',
  TOKEN_PRICE_FETCH_FAILED: 'Failed to fetch current token price',
  CONVERSION_ERROR: 'Error converting between USD and tokens'
};

export const SUCCESS_MESSAGES = {
  WALLET_CONNECTED: 'Wallet connected successfully',
  TRANSACTION_SENT: 'Transaction sent. Please wait for confirmation',
  STAKE_SUCCESS: 'Staking completed successfully',
  WITHDRAWAL_SUCCESS: 'Withdrawal completed successfully',
  APPROVAL_SUCCESS: 'Token approval successful',
  SETTINGS_UPDATED: 'Settings updated successfully',
  TOKEN_PRICE_UPDATED: 'Token price updated successfully'
};

// UPDATED: Format number with currency options
export const formatNumber = (num, decimals = 2, currency = null) => {
  if (isNaN(num)) return '0';
  const formatted = parseFloat(num).toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
  
  if (currency === 'USD') return `$${formatted}`;
  if (currency === 'TOKEN') return `${formatted} TRAIL`;
  return formatted;
};

// NEW: Format USD amounts
export const formatUSD = (amount, decimals = 2) => {
  return formatNumber(amount, decimals, 'USD');
};

// NEW: Format token amounts
export const formatTokens = (amount, decimals = 6) => {
  return formatNumber(amount, decimals, 'TOKEN');
};

// UPDATED: Format address
export const formatAddress = (address) => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

// UPDATED: Format time
export const formatTime = (timestamp) => {
  return new Date(timestamp * 1000).toLocaleString();
};

// UPDATED: Calculate days left
export const calculateDaysLeft = (endTime) => {
  const now = Math.floor(Date.now() / 1000);
  const secondsLeft = endTime - now;
  const daysLeft = Math.floor(secondsLeft / (24 * 60 * 60));
  return Math.max(0, daysLeft);
};

// UPDATED: Helper function to format large numbers (now for USD)
export const formatVolume = (volume, showCurrency = true) => {
  const num = parseFloat(volume);
  let formatted;
  
  if (num >= 1000000000) {
    formatted = `${(num / 1000000000).toFixed(2)}B`;
  } else if (num >= 1000000) {
    formatted = `${(num / 1000000).toFixed(2)}M`;
  } else if (num >= 1000) {
    formatted = `${(num / 1000).toFixed(1)}K`;
  } else {
    formatted = num.toFixed(2);
  }
  
  return showCurrency ? `$${formatted}` : formatted;
};

// NEW: Conversion helper functions
export const convertUsdToTokens = (usdAmount, tokenPrice) => {
  if (!tokenPrice || tokenPrice === 0) return 0;
  return usdAmount / tokenPrice;
};

export const convertTokensToUsd = (tokenAmount, tokenPrice) => {
  if (!tokenPrice) return 0;
  return tokenAmount * tokenPrice;
};

// NEW: Validation helpers
export const validateUsdAmount = (amount, planId) => {
  const plan = PLANS.find(p => p.id === planId);
  if (!plan) return { isValid: false, error: ERROR_MESSAGES.PLAN_NOT_FOUND };
  
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount) || numAmount <= 0) {
    return { isValid: false, error: ERROR_MESSAGES.INVALID_USD_AMOUNT };
  }
  
  if (numAmount < plan.min) {
    return { isValid: false, error: `${ERROR_MESSAGES.AMOUNT_TOO_LOW}. Minimum: ${formatUSD(plan.min)}` };
  }
  
  if (numAmount > plan.max) {
    return { isValid: false, error: `${ERROR_MESSAGES.AMOUNT_TOO_HIGH}. Maximum: ${formatUSD(plan.max)}` };
  }
  
  return { isValid: true, error: null };
};

// NEW: Check if user has sufficient token balance for USD amount
export const validateTokenBalance = (usdAmount, tokenBalance, tokenPrice) => {
  const requiredTokens = convertUsdToTokens(usdAmount, tokenPrice);
  return tokenBalance >= requiredTokens;
};

// NEW: Get plan by ID
export const getPlanById = (planId) => {
  return PLANS.find(plan => plan.id === planId);
};

// NEW: Check if plan requires referrals
export const planRequiresReferrals = (planId) => {
  const plan = getPlanById(planId);
  return plan ? plan.requiresReferrals : false;
};

// NEW: Wei conversion helpers (for blockchain)
export const parseEther = (value) => {
  return (parseFloat(value) * 1e18).toString();
};

export const formatEther = (value) => {
  return (parseFloat(value) / 1e18);
};

// NEW: Transaction helpers
export const getTransactionUrl = (hash, network = 'opBNB') => {
  const baseUrl = network === 'opBNBTestnet' 
    ? 'https://testnet.opbnbscan.com/tx/' 
    : 'https://opbnbscan.com/tx/';
  return `${baseUrl}${hash}`;
};

// NEW: Time formatting helpers
export const formatDuration = (seconds) => {
  const days = Math.floor(seconds / (24 * 60 * 60));
  const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((seconds % (60 * 60)) / 60);
  
  if (days > 0) return `${days}d ${hours}h`;
  if (hours > 0) return `${hours}h ${minutes}m`;
  return `${minutes}m`;
};

export const formatTimeRemaining = (endTimestamp) => {
  const now = Math.floor(Date.now() / 1000);
  const remaining = endTimestamp - now;
  
  if (remaining <= 0) return 'Expired';
  return formatDuration(remaining);
};